export enum SpecialOrderApprovalStatusEnum {
  PENDING = 0,
  APPROVED,
  DISAPPROVED,
}
